import { render, staticRenderFns } from "./LandingRegistroBebe.vue?vue&type=template&id=a2ae62ae"
import script from "./LandingRegistroBebe.vue?vue&type=script&lang=js"
export * from "./LandingRegistroBebe.vue?vue&type=script&lang=js"
import style0 from "./LandingRegistroBebe.vue?vue&type=style&index=0&id=a2ae62ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports